import axios from "axios";
import { getUserToken } from "../../utils/localStoarege";
import { exportPackageInvoiceAccountsApi } from "../../constants/apis/account_apis";

export const getHudInvoiceApi = async (pageSize = 100) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
        params: {
            page_size: pageSize,
        },
    };

    const response = await axios.get(
        exportPackageInvoiceAccountsApi,
        config,
    );

    return response;
};
